import * as MsalAuth from "./authConfig";

export async function callApiWithMsal(idToken, accessToken, fetch, url, options) {
    const headers = new Headers();
    const bearer = `Bearer ${idToken}`;
    headers.append("Authorization", bearer);
    headers.append("X-Access-Token", accessToken);

    if (Object.keys(options).length === 0) {
        options.method = "GET"
    }
    options.credentials = "same-origin"
    options.headers = headers

    return await fetch(url, options);
}

export const msalApiFetch = async (fetch, url, options) => {
    console.log("msalApiFetch called with url:", url);   
    
    var authResult = await MsalAuth.authToken();
    var idToken = authResult.idToken;
    var accessToken = authResult.accessToken;

    return await callApiWithMsal(idToken, accessToken, fetch, url, options);
}
